<div *ngIf="jobDetail$ | async as jobDescription">
  <div class="e11-relative e11-min-h-screen">
    <div class="e11-max-w-full e11-mx-auto">
      <div class="e11-relative e11-shadow-xl sm:e11-overflow-hidden e11-min-h-screen e11-flex e11-justify-center">
        <div class="e11-absolute e11-inset-0">
          <img class="e11-h-full e11-w-full e11-object-cover" src="{{ employerHeroImage }}" alt="" />
          <div [ngStyle]="{ 'background-color': employerTheme?.primary }" class="e11-absolute e11-inset-0 e11-mix-blend-multiply"></div>
        </div>

        <div class="e11-mx-auto e11-relative e11-p-4 md:e11-py-8 lg:e11-py-16 sm:e11-px-6 e11-pb-12 lg:e11-px-8 xl:e11-px-16 e11-w-full">
          <e11-panel
            [hasBorder]="false"
            containerClassOverrides="job-detail-panel e11-w-full e11-max-w-[1350px] e11-mx-auto e11-rounded-lg e11-overflow-hidden"
            contentClassOverrides="e11-p-0 e11-rounded-lg e11-overflow-hidden"
          >
            <div class="e11-justify-items-center e11-p-8" *ngIf="jobDescription?.jobPaused">
              <h3 class="e11-p-8 e11-font-bold e11-text-center">{{ 'UNFORTUNATELY THIS JOB POST IS CURRENTLY UNAVAILABLE' | translate }}</h3>
              <p class="e11-mt-4 e11-text-lg e11-text-gray-500">{{ 'Please click on the logo to return to careers' | translate }}</p>
            </div>
            <div *ngIf="!jobDescription?.jobPaused">
              <div *ngIf="jobDetail$ | async as jobDescription">
                <div class="e11-grid e11-grid-cols-1 lg:e11-grid-cols-2 e11-gap-0">
                  <div
                    style="background: linear-gradient(to bottom left, var(--color-skin-primary-accent, #0080d3), var(--color-skin-primary, #033c6d))"
                  >
                    <div class="e11-flex e11-flex-col e11-p-6 sm:e11-p-8">
                      <div class="e11-flex e11-flex-row e11-items-center e11-justify-start e11-flex-wrap sm:e11-flex-nowrap">
                        <div>
                          <img
                            class="e11-float-left e11-h-12 e11-w-auto e11-mr-4"
                            *ngIf="jobDescription.employerLogo"
                            [src]="jobDescription.employerLogo"
                            [alt]="jobDescription.employerName"
                          />
                        </div>
                        <div class="e11-grow e11-text-skin-white">
                          <h3 class="e11-mb-1">{{ jobDescription.jobTitle }}</h3>
                          <h5>{{ jobDescription.employerName }}</h5>
                        </div>
                      </div>
                      <e11-divider [color]="'e11-bg-skin-white'" [margin]="1"></e11-divider>
                      <div class="e11-grid e11-grid-cols-1 sm:e11-grid-cols-2 e11-text-skin-white">
                        <h5 class="e11-text-left e11-mb-2 e11-text-sm sm:e11-text-base">
                          <span class="e11-font-bold">{{ 'Location:' | translate }}</span>
                          {{ jobDescription.locationAddress?.city
                          }}<span *ngIf="jobDescription.locationAddress?.state">, {{ jobDescription.locationAddress?.state }}</span
                          >, {{ jobDescription.locationAddress?.countryCode }}
                        </h5>
                        <h5 class="e11-text-left e11-mb-2 e11-text-sm sm:e11-text-base">
                          <span class="e11-font-bold">{{ 'Employment Type:' | translate }}</span>
                          {{ jobDescription.employmentType | employmentType | translate }}
                        </h5>
                        <h5 *ngIf="jobDescription.experienceLevel" class="e11-text-left e11-mb-2 e11-text-sm sm:e11-text-base">
                          <span class="e11-font-bold">{{ 'Experience:' | translate }}</span>
                          {{ jobDescription.experienceLevel | experienceLevel | translate }}
                        </h5>
                        <h5 *ngIf="jobDescription.educationLevel" class="e11-text-left e11-mb-2 e11-text-sm sm:e11-text-base">
                          <span class="e11-font-bold">{{ 'Education:' | translate }}</span>
                          {{ jobDescription.educationLevel | degreeLevel | translate }}
                        </h5>
                      </div>
                      <div>
                        <img class="e11-mb-2 e11-w-40 sm:e11-w-48" alt="Cnect Logo" src="/assets/images/logo/cnect-white.png" />
                      </div>
                      <div class="e11-text-skin-white e11-text-sm sm:e11-text-base">
                        <p class="e11-mb-0.5">
                          {{ 'Applying for this job is easy with Cnect!' | translate }}
                        </p>
                        <p class="e11-mb-0">
                          {{
                            'If you have an account login and take advantage of all of the features Cnect offers that makes applying for, interviewing and landing a job quick and easy.'
                              | translate
                          }}
                        </p>
                      </div>
                      <e11-divider [color]="'e11-bg-skin-white'" [margin]="1"></e11-divider>
                      <div class="e11-flex e11-flex-row e11-items-center e11-justify-start e11-text-skin-white e11-mb-2">
                        <span class="material-symbols-outlined e11-text-4xl sm:e11-text-5xl e11-mr-2">export_notes</span>
                        <h6 class="e11-text-sm sm:e11-text-base">
                          {{
                            'Also, remember that once you log in applying for this job can be quick and easy by uploading your existing resume and letting us do the rest!'
                              | translate
                          }}
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div class="e11-relative e11-bg-skin-white e11-p-6 sm:e11-p-8">
                    <div class="e11-hidden lg:e11-block e11-h-[36px]"></div>

                    <e11-tabs
                      #tabs
                      [selectedTabId]="activeTab"
                      [tabTitleOverrides]="'e11-text-base sm:e11-text-lg lg:e11-text-xl'"
                      [tabsClassOverrides]="'e11-justify-between e11-flex-col sm:e11-flex-row'"
                      [tabClassOverrides]="'e11-mr-0 e11-mb-2 sm:e11-mb-0'"
                    >
                      <e11-tab [tabId]="'register'" title="{{ 'Start your application' | translate }}">
                        <div class="md:e11-border-t e11-border-skin-app-bg-borders e11-py-2">
                          <h5 class="e11-text-left e11-mb-4 e11-text-base">
                            {{ 'A quick few pieces of information...' | translate }}
                          </h5>
                          <div class="e11-p-4 sm:e11-p-6">
                            <div class="e11-flex e11-flex-col e11-justify-center e11-items-center">
                              <div class="e11-flex e11-justify-center e11-mb-6 e11-w-full">
                                <div class="e11-flex e11-items-center">
                                  <div
                                    class="e11-w-10 e11-h-10 sm:e11-w-12 sm:e11-h-12 e11-rounded-full e11-flex e11-items-center e11-justify-center e11-font-semibold e11-text-base sm:e11-text-lg e11-border-2 e11-transition-all"
                                    [ngClass]="
                                      registrationStep === 1
                                        ? 'e11-bg-white e11-text-gray-400 e11-border-green-500'
                                        : 'e11-bg-green-500 e11-text-white e11-border-green-500 e11-cursor-pointer hover:e11-opacity-80'
                                    "
                                    (click)="registrationStep === 2 ? backToStep1() : null"
                                  >
                                    1
                                  </div>
                                  <div
                                    class="e11-w-16 sm:e11-w-24 e11-h-1 e11-mx-2 e11-transition-all"
                                    [ngClass]="registrationStep === 2 ? 'e11-bg-green-500' : 'e11-bg-gray-300'"
                                  ></div>
                                  <div
                                    class="e11-w-10 e11-h-10 sm:e11-w-12 sm:e11-h-12 e11-rounded-full e11-flex e11-items-center e11-justify-center e11-font-semibold e11-text-base sm:e11-text-lg e11-border-2 e11-transition-all"
                                    [ngClass]="
                                      registrationStep === 2
                                        ? 'e11-bg-white e11-text-gray-400 e11-border-green-500'
                                        : 'e11-bg-white e11-text-gray-400 e11-border-gray-300'
                                    "
                                  >
                                    2
                                  </div>
                                </div>
                              </div>

                              <div
                                #registrationWrapper
                                class="e11-relative e11-w-full e11-max-w-full sm:e11-max-w-[460px]"
                                [ngClass]="{
                                  'registration-step-1': registrationStep === 1,
                                  'registration-step-2': registrationStep === 2
                                }"
                              >
                                <sdk-registration-consumer
                                  submitButtonText="{{ 'Continue' | translate }}"
                                  (onSubmit)="onSubmit($event)"
                                  (termsClicked)="termsClicked()"
                                ></sdk-registration-consumer>

                                <div class="e11-w-full" [ngClass]="{ 'e11-hidden': registrationStep !== 1 }">
                                  <e11-button
                                    id="step1_continue"
                                    value="{{ 'Continue' | translate }}"
                                    [color]="'primary-accent'"
                                    [type]="'button'"
                                    [display]="'block'"
                                    (click)="continueToStep2()"
                                  >
                                  </e11-button>
                                </div>
                              </div>

                              <cnect-loader-link
                                *ngIf="uploadingResume"
                                [size]="'md'"
                                [fullScreen]="true"
                                [color]="'e11-bg-skin-primary-accent'"
                                [hasBackdrop]="true"
                                [backdropStyle]="'dark'"
                                [fontColor]="'e11-text-white'"
                                label="{{ 'Finalizing application... please wait a moment.' | translate }}"
                              ></cnect-loader-link>
                            </div>
                          </div>
                        </div>
                      </e11-tab>
                      <e11-tab [tabId]="'login'" title="{{ 'I have a Cnect Account' | translate }}">
                        <div class="md:e11-border-t e11-border-skin-app-bg-borders">
                          <div class="e11-px-4 sm:e11-px-6 e11-py-12 e11-max-w-full sm:e11-max-w-[460px] e11-mx-auto">
                            <auth-login (onSubmit)="onSubmitLogin($event)" (onForgottenPassword)="onForgottenPassword()"></auth-login>
                          </div>
                        </div>
                      </e11-tab>
                    </e11-tabs>
                  </div>
                </div>
              </div>
            </div>
          </e11-panel>
        </div>
      </div>
    </div>
  </div>
</div>
